import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.onClickOutside = this.onClickOutside.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
    if (!this.menuTarget.classList.contains("hidden")) {
      document.addEventListener("click", this.onClickOutside)
    }
  }

  onClickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.onClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.onClickOutside)
  }
}
